
import { classUpDownConverter } from '~/utils'

export default {
    name: 'FeaturesTable',
    props: {
        newsItems: Array,
        searchType: {
            type: String,
            default: 'date' // 'date' or 'stock'
        }
    },

    watch: {
        newsItems() {
            this.sortList()
        },
    },

    data() {
        return {
            sortItems: [],
        }
    },

    methods: {
        triangleSpliter(target) {
            if (target !== null) {
                const TRegexp = /(?=▷)/gi
                const splitStr = target.split(TRegexp)
                // 22.05.04 suye 그룹종목 현출 수정
                if(splitStr[splitStr.length-1].includes('[종목]:')){       
                    splitStr[splitStr.length-1] = splitStr[splitStr.length-1].substring(0, splitStr[splitStr.length-1].lastIndexOf('\n'))
                }
                return splitStr
            }
        },
        // 백분율계산
        percent(rate) {
            if (typeof rate !== 'number') return '자료없음'

            const sign = Math.sign(rate)
            let num = Math.abs(rate)
            let text = ''
            num = num / 100
            num = num.toFixed(2)
            
            text = sign === 1 ? '+ ' : '- '
            text = text + String(num).concat('%')

            return text
        },

        upDownCssApply(value) {
            return classUpDownConverter(value)
        },

        // 내림차순 정렬
        sortList() {
            if (!Array.isArray(this.newsItems)) return

            const copyObject = [...this.newsItems]

            if (this.searchType === 'stock') {
                // 종목검색일 경우: 날짜 최신순 정렬
                this.sortItems = copyObject.sort((a, b) => {
                const dateA = new Date(a[0].showDate)
                const dateB = new Date(b[0].showDate)
                return dateB - dateA // 최신날짜순
                })
            } else {
                // 날짜검색일 경우: 기존처럼 코스피/코스닥 분리 후 등락률 정렬
                const kospiList = copyObject.filter(item => item[0].TRADING_MARKET0 === 'Y')
                const kosdaqList = copyObject.filter(item => item[0].TRADING_MARKET0 === 'K')

                const kospiListResult = kospiList.sort((a, b) => b[0].changeRate - a[0].changeRate)
                const kosdaqListResult = kosdaqList.sort((a, b) => b[0].changeRate - a[0].changeRate)

                this.sortItems = kospiListResult.concat(kosdaqListResult)
            }
        },

        // 그룹주 종목
        stockNmJoin(value) {
            console.log(value)
            let joinText = ''
            for (let i = 0; i < value.length - 1; ++i) {
                joinText += value[i].stockName + ', '
            }
            joinText += value[value.length - 1].stockName
            return joinText
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
    },
}
